export default __webpack_public_path__ + "static/media/car-insurance.c0085b10.svg";